var portfolioBreakdown = {
	table: {
		caption: "Portfolio Zusammensetzung",
		name: {
			assetClass: "Anlagekategorien",
			currency: "Währungen",
			sector: "Sektoren"
		}
	},
	chart: {
		counting: {
			assetClass: "Anlageklassen",
			currency: "Währungen",
			sector: "Sektoren"
		},
		topPositions: {
			assetClass: "Top Anlageklassen",
			currency: "Top Währungen",
			sector: "Top Sektoren"
		}
	},
	assetClasses: {
		bond: "Anleihe",
		commodity: "Rohstoff",
		currency: "Währung",
		debt: "Schuldtitel",
		etf: "ETF",
		fund: "Fonds",
		generic: "Sonstige",
		index: "Index",
		stock: "Aktie",
		interestRate: "Zinsen",
		structuredProduct: "Strukturiertes Produkt",
		investmentProduct: "Anlageprodukt",
		leveragedProduct: "Hebelprodukt",
		option: "Option",
		future: "Future"
	}
};
var de = {
	portfolioBreakdown: portfolioBreakdown
};

export { de as default, portfolioBreakdown };
